import * as AWS from 'aws-sdk'
import Router from '../router'

class AuthService {
  AccessKeyId
  SecretKey
  SessionToken
  awsRegion
  identityId
  accessToken
  expireTime
  idToken
  emailID
  user
  firstname
  async authenticate () {
    if (localStorage.getItem('accesstoken') && localStorage.getItem('idToken') && new Date() <= new Date(Number(localStorage.getItem('idToken_expiry')))) {
      localStorage.setItem('curURL', window.location.href)

      if (!this.expireTime || new Date() > new Date(this.expireTime)) {
        return await this.validateWithCognito();
      } else {
        return true
      }
    } else {
      this.validateForTokenID()
      return false
    }
  }

  async validateWithCognito () {
    const instance = this
    const idToken = localStorage.getItem('idToken')
    var logins = {}
    logins[process.env.VUE_APP_provider_url] = idToken
    // Parameters required for CognitoIdentityCredentials
    var params = {
      IdentityPoolId: process.env.VUE_APP_pool_id,
      Logins: logins
    }
    AWS.config.region = process.env.VUE_APP_aws_region
    AWS.config.credentials = new AWS.CognitoIdentityCredentials(params)
    const result = await new Promise(function (resolve, reject) {
      (AWS.config.credentials).get((err) => {
        if (err) {
          localStorage.removeItem('idToken')
          instance.validateForTokenID()
          resolve(false)
        } else {
          instance.expireTime = (AWS.config.credentials).expireTime
          instance.identityId = (AWS.config.credentials).identityId
          instance.AccessKeyId = (AWS.config.credentials).accessKeyId
          instance.SecretKey = (AWS.config.credentials).secretAccessKey
          instance.SessionToken = (AWS.config.credentials).sessionToken
          instance.accessToken = localStorage.getItem('accesstoken')
          instance.idToken = localStorage.getItem('idToken')
          instance.aws_region = process.env.VUE_APP_aws_region
          //parsing idToken
          instance.emailID = instance.parseJwt(instance.accessToken).sub;
          instance.user = instance.emailID.split('.')
          instance.firstname = instance.user[0]
          resolve(true)
        }
      })
    })
    return result
  }

  validateForTokenID () {
    const callbackUrl = window.location.href
    const match = callbackUrl.match('id_token=([^&]*)')
    const error = callbackUrl.match('error=([^&]*)')
    const accessToken = callbackUrl.match('access_token=([^&]*)')
    let idToken
    let acctoken
    if (match) {
      idToken = match[1]
      acctoken = accessToken[1]
    }
    if (idToken) {
      localStorage.setItem('idToken', idToken)
      localStorage.setItem('accesstoken', acctoken)
      // this.accessToken = acctoken
      const expiry = callbackUrl.match('expires_in=([^&]*)')
      const expiryDate = new Date().setSeconds(new Date().getSeconds() + Number(expiry[1]))
      localStorage.setItem('idToken_expiry', expiryDate.toString())
      if (localStorage.getItem('curURL')) {
        //window.location.href= process.env.VUE_APP_redirect_uri
        window.location.replace(localStorage.getItem('curURL'))
      } else { Router.go('/home') }

    } else {
      if (error && error[1] === 'access_denied') {
        Router.go('path')
      } else {
        const url = process.env.VUE_APP_adfsURL + '?client_id=' + process.env.VUE_APP_client_id + '&redirect_uri=' + process.env.VUE_APP_redirect_uri +
          '&nonce=' + this.makeid(16) + '&state=' + this.makeid(16) + '&response_type=token id_token' + '&scope=openid profile email'
        window.location.href = url
      }
    }
  }
  makeid (length) {
    var result = ''
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }
  clearLocalstorage() {
    localStorage.removeItem('curURL');
    localStorage.removeItem('id_token');
  }
  parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }
}
export default new AuthService()
